module.exports = __webpack_public_path__ + "img/icon_footer_palysvg.e69bc2cb.svg";